import { render } from "./BranchAlias.vue?vue&type=template&id=4684c93c&scoped=true"
import script from "./BranchAlias.vue?vue&type=script&lang=js"
export * from "./BranchAlias.vue?vue&type=script&lang=js"

import "./BranchAlias.vue?vue&type=style&index=0&id=4684c93c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4684c93c"]])

export default __exports__